<template>
	<div  :aria-busy="loading ? 'true' : 'false'">
		<section class="content__custom" v-if="!loading">
			<div class="main-title">
				<h1 class="groups">
					{{ 'groups' | translate | titleCase }}
				</h1>
			</div>
			<div v-if="groups">
				<div v-if="groups.length > 1">
					<table class="table--fixed table-navigation">
						<thead>
							<tr>
								<th class="group-cell">{{ 'group' | translate | titleCase }}</th>
								<th class="date-cell">{{ 'created at' | translate | titleCase }}</th>
								<th class="supporters-cell">{{ 'supporters' | translate | titleCase }}</th>

							</tr>
						</thead>
						<tfoot v-if="groups.length > 10">
							<tr>
								<th class="group-cell">{{ 'group' | translate | titleCase }}</th>
								<th class="date-cell">{{ 'date' | translate | titleCase }}</th>
								<th class="supporters-cell">{{ 'supporters' | translate | titleCase }}</th>
							</tr>
						</tfoot>
						<tbody>
							<tr v-for="group in groups" :key="group.id" @click="editGroup(group.id, group.status )">
								<td :title="'groups' | translate" class="group-cell"> {{ group.name }}</td>
								<td :title="'date' | translate" class="date-cell">{{ group.created_at | date }}</td>
								<td :title="'supporters' | translate" class="supporters-cell"><span v-if="group.status === 'ready'" class="supporters-cell__content">{{ group.recipients_count }}</span><span v-else class="status-cell__content">{{ 'processing' | translate | titleCase }}</span></td>
							</tr>
						</tbody>
					</table>

					<pagination
					:classNames="'pagination-arrows pull-right'"
					dispatchToCall="getGroupsList"
					:itemsPerPageProp="session.results"
					:totalItensPagesProps="totalPages"
					:totalItens="totalItems"
					:totalPagesProp="this.totalPages"
					></pagination>
				</div>
				<div v-else>
					<p class="empty-state">
						{{ 'no-groups' | translate | capitalize }}
					</p>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
import pagination from '../../components/pagination/pagination.vue';

export default {
	name: 'groups-list',
	components: {
		pagination,
	},
	data() {
		return {
			session: {
				page: 1,
				results: 20,
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			loading: false,
			picked: 'all',
			notExist: {},
			verifyStatus: '',
		};
	},
	computed: {
		groups: {
			get() {
				return (this.$store.state.group.groups || {}).groups || {};
			},
			set(value) {
				this.groups = value;
			},
		},
		pendingGroupStatus: {
			get() {
				return (this.groups || {}).filter(g => g.status === 'processing').length;
			},
			set(value) {
				this.pendingGroupStatus = value;
			},
		},
		totalItems() {
			return (this.$store.state.group.groups || 0).itens_count || 0;
		},
		totalPages: {
			get() {
				return this.totalItems / this.session.results || 0;
			},
			set() {
			},
		},
	},
	methods: {
		toggleLoading() {
			this.loading = !this.loading;
		},
		collapsePainel(event) {
			$.AdminLTE.boxWidget.collapse($(event.target));
		},
		editGroup(groupId, status) {
			if (status !== 'processing') {
				this.$router.push({ path: `/grupos/editar/${groupId}` });
			}
		},
		imgUrl(path) {
			return images(`./${path}`);
		},
		verifyStatusGroup() {
			const timer = setInterval(() => {
				if (this.pendingGroupStatus) {
					this.$store.dispatch('getGroupsList', this.session);
				} else {
					clearInterval(timer);
				}
			}, 2000);
		},
	},
	mounted() {
		this.toggleLoading();
		this.$store.dispatch('getGroupsList', this.session)
			.then(() => {
				this.verifyStatusGroup();
				this.toggleLoading();
			})
			.catch(() => {
				this.toggleLoading();
			});
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/group/groups.vue